export const DEFAULT_SORTING = { sorting: '-date' };
